import React from "react";
import ct from "class-types.macro";
import SubmissionResult from "~/Brochure/SubmissionResult/SubmissionResult";
import EmailSignupFormErrors from "./EmailSignupFormErrors";
import NewItemsInput from "~/common/Form/NewItemsInput";
interface Props {
  isSubmitting: boolean;
  submissionResponse: SubmissionResult | "GeneralFailure" | undefined;
}
const divStyle = {
  height: "42px"
};
function EmailSignupForm({
  isSubmitting,
  submissionResponse
}: Props) {
  return <>
      <div className={ct("flex")}>
        <div className="flex-grow">
          <NewItemsInput type="text" placeholder="Email Address" name="EmailAddress" label="" className={ct("rounded-r-none")} aria-label="Enter Your Email Address to Sign up for new item alerts" data-sentry-element="NewItemsInput" data-sentry-source-file="EmailSignupForm.tsx" />
        </div>
        <div className="flex-none">
          <button type="submit" disabled={isSubmitting} name="btnNewItemSubmit" className={`btn btn-small btn-ui ${ct("rounded-l-none", "h-8")}`} style={divStyle}>
            Sign Up
          </button>
        </div>
      </div>
      <EmailSignupFormErrors submissionResponse={submissionResponse} data-sentry-element="EmailSignupFormErrors" data-sentry-source-file="EmailSignupForm.tsx" />
    </>;
}
export default EmailSignupForm;